import { WA_DEFAULT_LINK, WA_NUMBER_DISPLAY } from '../lib/lead';

export default function TopBar() {
  return (
    <div className="bg-brand-bluedark text-white relative z-[60]" data-testid="top-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-center gap-2 text-center">
        <p className="text-[11px] sm:text-xs font-medium leading-snug">
          Got a Court Notice or Pending Challan? Settle legally before impound or court summons.{' '}
          <a
            href={WA_DEFAULT_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="top-bar-whatsapp-link"
            className="text-brand-orange font-bold hover:text-white transition-colors"
          >
            WhatsApp: {WA_NUMBER_DISPLAY}
          </a>{' '}
          <span className="hidden sm:inline text-white/60">| Pan-India Service</span>
        </p>
      </div>
    </div>
  );
}
